import { render, staticRenderFns } from "./vue-cropper.vue?vue&type=template&id=cf97cc52&scoped=true&"
import script from "./vue-cropper.vue?vue&type=script&lang=js&"
export * from "./vue-cropper.vue?vue&type=script&lang=js&"
import style0 from "./vue-cropper.vue?vue&type=style&index=0&id=cf97cc52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf97cc52",
  null
  
)

export default component.exports